// @mui material components
import TableCell from "@mui/material/TableCell";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

// Declaring prop types for SalesTableCell
interface Props {
  content?: string | number;
  titleRow?: string;
  noBorder?: boolean;
  [key: string]: any;
}

function TableCellCustom({ title, content, titleRow, noBorder, ...rest }: Props): JSX.Element {
  let template;

  if (titleRow) {
    template = (
      <TableCell
        {...rest}
        align="left"
        width="30%"
        sx={{ border: noBorder ? 0 : undefined, py: 0.5 }}
      >
        <MDBox display="flex" alignItems="flex-end" width="max-content">
          <MDTypography variant="body2" fontWeight="bold">
            {titleRow}
          </MDTypography>
        </MDBox>
      </TableCell>
    );
  } else {
    template = (
      <TableCell {...rest} sx={{ border: noBorder && 0, py: 0.8 }}>
        {content !== undefined && content !== null && (
          <MDTypography variant="body2" fontWeight="medium" sx={{ whiteSpace: "pre-wrap" }}>
            {content}
          </MDTypography>
        )}
      </TableCell>
    );
  }

  return template;
}

// Declaring default props for TableCellCustom
TableCellCustom.defaultProps = {
  image: "",
  noBorder: false,
};

export default TableCellCustom;
